import { render } from "./SyndicatedStory.vue.js?vue&type=template&id=b56bf40a&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStory.vue?vue&type=template&id=b56bf40a&scoped=true"
import script from "./SyndicatedStory.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStory.vue?vue&type=script&lang=js"
export * from "./SyndicatedStory.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStory.vue?vue&type=script&lang=js"

import "./SyndicatedStory.vue.scss?vue&type=style&index=0&id=b56bf40a&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStory.vue?vue&type=style&index=0&id=b56bf40a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56bf40a"],['__file',"src/Web/scripts/pages/stories/SyndicatedStory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b56bf40a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b56bf40a', __exports__)) {
    api.reload('b56bf40a', __exports__)
  }
  
  module.hot.accept("./SyndicatedStory.vue.js?vue&type=template&id=b56bf40a&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStory.vue?vue&type=template&id=b56bf40a&scoped=true", () => {
    api.rerender('b56bf40a', render)
  })

}


export default __exports__